export function translate(literal, vars) {
  return literal.replace(/{([a-zA-Z_]+)}/g, (_, key) => vars[key] ?? key);
}
